import { actions as notificationActions } from '@saucelabs/sl-container-notifications';
import { batchRequests } from '@saucelabs/sl-util-helpers';

export const createTestListOperations = ({
  actions,
  selectors,
  operations,
  filterOperations,
}) => ({
  getTests: () => (dispatch, getState) => {
    const params = selectors.getParams(getState());
    return dispatch(actions.getTests(params)).then((data) => {
      const tests = data?.data?.items || [];
      const usersRequests = tests.map((test) => (
        () => dispatch(operations.getTestOwner(test))
      ));
      batchRequests(usersRequests, 1);
      return Promise.resolve(tests);
    });
  },

  changePage: (payload) => async (dispatch) => {
    await dispatch(actions.changePage(payload));
    return dispatch(operations.getTests());
  },

  changeSorting: (payload) => (dispatch) => {
    dispatch(actions.changeSorting(payload));
    return dispatch(operations.getTests());
  },

  refreshTests: () => (dispatch) => {
    dispatch(actions.resetPage());
    return Promise.all([
      dispatch(operations.getTests()),
      dispatch(operations.getTestCasesTrends()),
    ]);
  },

  getTestOwner: (test) => (dispatch, getState) => {
    const { user_id: userId, id } = test;
    const user = selectors.getUser(getState(), { userId });
    if (user) {
      dispatch(actions.updateTestOwner({ id, owner: user.username }));
      return Promise.resolve();
    }

    return dispatch(actions.fetchUser({ id: userId }))
      .then(({ data: { username } }) => (
        dispatch(actions.updateTestOwner({ id, owner: username }))
      )).catch((error) => (
        // Do nothing with error
        console.warn(error.message) // eslint-disable-line no-console
      ));
  },

  changeTrendsInterval: (payload) => (dispatch) => {
    dispatch(actions.changeTrendsInterval(payload));
    return dispatch(operations.getTestCasesTrends());
  },

  changeSelectedBar: (payload) => (dispatch) => {
    dispatch(actions.changeSelectedBar(payload));
    return dispatch(operations.getTests());
  },

  getTestCasesTrends: () => (dispatch, getState) => {
    const params = selectors.testCasesTrendsParamsSelector(getState());
    return dispatch(actions.getTestCasesTrends(params));
  },

  cleanup: () => (dispatch) => (
    dispatch(actions.cleanup())
  ),

  initialize: (options) => (dispatch) => Promise.all([
    dispatch(actions.initialized()),
    dispatch(filterOperations.initialize(options)),
    dispatch(actions.fetchUsers()),
  ]).then(() => (
    Promise.all([
      dispatch(operations.getTests()),
      dispatch(operations.getTestCasesTrends()),
    ])
  )).catch((error) => {
    dispatch(notificationActions.notifyDanger(
      error.message, 'We\'ve experienced an issue loading tests.', true,
    ));
  }),
});
